import { GetFiltersLimitsResponse, GetPoolsResponse, GetPoolsStatsResponse, PoolsQueryParams } from 'types/poolsService';
import { $client } from './client';
import { createQueryParamsForPools } from 'utils/createQueryParamsForPools';
import { getAccessToken } from 'utils/auth';

export class PoolsService {
  async getPools(params: PoolsQueryParams) {
    try {
			const uri = createQueryParamsForPools({...params})
      const endpoint = `/api/pools/admin?${uri}`;

      const response = await $client.get<GetPoolsResponse>(endpoint, {
				headers: { authorization: getAccessToken() }
			});

      return response.data;
    } catch (error) {
      console.error(error);

      throw new Error(
        'Something went wrong, try to reload the page, or contact support.'
      );
    }
  }

	async getFiltersLimits(networkId: string) {
    const res = await $client.get<GetFiltersLimitsResponse>(
      '/api/pools/filters/limits',
      { params: { networkId } }
    );

    return res.data;
  }
	async getPoolsStats(networkId: string) {
    const res = await $client.get<GetPoolsStatsResponse>(
      '/api/pools/admin/stats',
      { params: { networkId }, headers: { authorization: getAccessToken() } }
    );

    return res.data;
  }
}

export const poolsService = new PoolsService();